import { createElement } from './utils/dom';
import { getClasses, getModifiers } from './DayModifiers';

export function Day(date, month, config) {
	let td = createElement('td');
	let button = createElement('button');

	let modifiers = getModifiers(date, month, config);

	function focus() {
		button.focus();
		enableKeyboardFocus();
	}

	function blur() {
		button.blur();
		disableKeyboardFocus();
	}

	function enableKeyboardFocus() {
		button.setAttribute('tabindex', '0');
	}

	function disableKeyboardFocus() {
		button.setAttribute('tabindex', '-1');
	}

	function render() {
		let tabIndex = modifiers.today ? '0' : '-1';

		td.className = getClasses(modifiers, config.classes).join(' ');
		td.setAttribute('role', 'gridcell');

		if (!modifiers.hidden) {
			td.append(button);
		}

		button.className = config.classes.dayButton;

		button.setAttribute('type', 'button');
		button.setAttribute('tabindex', tabIndex);
		button.setAttribute('aria-hidden', modifiers.hidden);
		button.setAttribute('aria-disabled', modifiers.disabled);
		button.setAttribute('aria-selected', modifiers.selected);

		button.addEventListener('click', handleClick);
		button.addEventListener('focus', handleFocus);
		button.addEventListener('keydown', handleKeydown);

		button.innerHTML = date.getDate();


		if (!modifiers.hidden) {
			td.append(button);
		}

		function handleFocus(event) {
			let focus = new CustomEvent('dayFocus', {
				bubbles: true,
				detail: { ...day, event },
			});

			event.target.dispatchEvent(focus);
		}

		function handleClick(event) {
			if (modifiers.disabled) {
				return event.stopPropagation();
			}

			let click = new CustomEvent('dayClick', {
				bubbles: true,
				detail: { ...day, event },
			});

			event.stopPropagation();
			event.target.dispatchEvent(click);
		}

		function handleKeydown(event) {
			let keys = [
				'ArrowUp',
				'ArrowDown',
				'ArrowLeft',
				'ArrowRight',
			];

			let keydown = new CustomEvent('dayKeydown', {
				bubbles: true,
				detail: { ...day, event },
			});

			if (keys.includes(event.key)) {
				event.preventDefault();
			}

			event.target.dispatchEvent(keydown);
		}

		return td;
	}

	let day = {
		date,
		blur,
		focus,
		render,
		modifiers,
		element: button,
		enableKeyboardFocus,
		disableKeyboardFocus,
	};

	for (const [key, value] of Object.entries(config)) {
		if (key[0] !== 'o' && key[1] !== 'n') {
			continue;
		}

		// todo add a check to see if it's a valid event name

		let name = key.toLowerCase().slice(2);
		button.addEventListener(name, event => value(day, event));
	}

	return day;
}
